<div class="module-disabled-page">
  <div class="breadcrumb" *ngIf="parentLabel || moduleLabel">
    <span *ngIf="parentLabel">{{ parentLabel | translate | uppercase }}</span>
    <span *ngIf="parentLabel && moduleLabel"> &gt; </span>
    <span *ngIf="moduleLabel">{{ moduleLabel | translate | uppercase }}</span>
  </div>

  <div class="card">
    <div class="lock-icon">
      <i class="pi pi-lock-open"></i>
    </div>
    <h2 class="title">Módulo não habilitado</h2>
    <p class="description">
      Esta funcionalidade não está disponível para sua marina no momento.
      Caso deseje utilizar este recurso, entre em contato com o suporte da
      Easymarine para solicitar a habilitação.
    </p>
    <button class="support-button" type="button" (click)="openWhatsappSupport()">
      <i class="pi pi-comments"></i>
      <span>Falar com Suporte</span>
    </button>
  </div>
</div>
